import React, { useEffect } from 'react';
import Typed from 'typed.js';
import '../../../UI Design/Home.css';
import Image from '../../../assets/Images/sample.png'
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function Home() {
    useEffect(() => {
        const options = {
            strings: ['Full Stack Developer'],
            typeSpeed: 100,
            backSpeed: 20,
            loop: true,
        };

        const typed = new Typed('.typed-element', options);

        return () => {
            // Destroy Typed instance during cleanup to stop animation
            typed.destroy();
        };
    }, []);

    return (
        <div className='home' id='home'>
            <div className='home-content'>
                <h3>Hello, It's Me</h3>
                <h1>Althaf Hussain</h1>
                <h3>And I'am a <span className='typed-element'></span></h3>
                <p>I'm always excited to collaborate on new projects and ideas. Whether you're looking to build a new application from scratch or need an expert to improve your existing platform, let's connect and create something amazing together.</p>
                <div className='social-media-container'>
                    <a href='https://wa.me/+919384392655?text=Hello!' className='btn2'>
                        <i className='bx bxl-whatsapp'></i> Let's Talk!
                    </a>
                    <h2>/</h2>
                    <div className='social-media'>
                        <a href='https://x.com/Althafx2005' target='_blank' rel='noopener noreferrer'>
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a href='https://www.linkedin.com/in/althaf-hussain-6a9a9530b' target='_blank' rel='noopener noreferrer'>
                            <i className="fab fa-linkedin"></i>
                        </a>
                    </div>

                </div>
            </div>

            <div className="home-img">
                <img src={Image} alt='Network Error' onError={(e) => e.target.style.display = 'none'} />
            </div>
        </div>

    )
}
